export default __webpack_public_path__ + "static/media/connection.d5747e6e.svg";